module.exports = __webpack_public_path__ + "static/img/2-19.98e439e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-19.png
// module id = eRbg
// module chunks = 15